import { image } from 'services'
import { measurements, fontSizesMobile } from 'theme'
import css from 'styled-jsx/css'
import colors from 'theme/colors'

export default css.global`
 .video-frame{
    width: 100vw;
    background-image: url(${image('landing/section/', 'video-frame.jpg')});
    height: 350px;
    color: ${colors.white};
    background-size: cover;
  }
  .video-container img{
    margin-bottom: 10px;
  }
  .video-container p{
    font-size:1.5rem;
    text-align: center;
  }
  .video-container h2{
    font-size: 2.25rem;
    font-weight: 600;
    color: ${colors.white};
    margin-bottom: 0;
  }

  .video-container{
    justify-content: center;
  }
  @media screen and (max-width: 992px) {
    .video-frame{
      padding: 1rem;
      text-align: center;
    }
    .video-container h2{
      font-size: ${fontSizesMobile.h2}
    }
    .video-container p{
      font-size: ${fontSizesMobile.p}
    }
  } 
`

export const videoStyles = css`
  .wrapper {
    position: relative;
    padding-top: 56.25%
  }
  .wrapper :global(.react-player) {
    position: absolute;
    top: 0;
    left: 0;
  }
`
